import React from 'react';
import 'ol/ol.css';
import { Box } from '@mui/system';
import { CircularProgress } from '@mui/material';
import { useRecoilValue } from 'recoil';
import mapState from 'state/mapState';

const BaseMap = () => {
  const { status } = useRecoilValue(mapState);

  return (
    <>
      <div
        id="crop_map"
        className="mapArea"
      ></div>
      {status.loadStart ? (
        <CircularProgress
          size="lg"
          sx={{
            width: 70,
            height: 70,
            position: 'absolute',
            top: '50%',
            left: '50%',
          }}
        />
      ) : null}
    </>
  );
};

export default BaseMap;
